export default __webpack_public_path__ + "static/media/PhilosophiesProgramming.5864425f.PNG";